/* eslint-disable @typescript-eslint/no-unused-vars */
import { Howl, Howler } from 'howler';

import notificationSound from '@assets/sounds/notification.mp3';
import { NotificationService } from '@setup/notifications//SnackbarUtilsConfigurator/SnackbarUtilsConfigurator';

import { setChatCounters } from '../Common/commonSlice';

import { addThreadsItems, deleteThreadsItem, changeThreadCounter } from './chatSlice';
import {
  addThread,
  fastMessageSend,
  fastReplyMessageSend,
  getGlobalChatCounters,
  getThreadCounter,
  seenReply,
  seenThread,
  updateThread,
} from './chatThunk';

import type { AppDispatch, RootState } from '../store';
import type { MessageModel, ThreadModel } from '@shared/models/chat/chat.model';

export type ChatSocketType = {
  message: MessageModel;
  thread: ThreadModel;
};

export const chatGlobalSocketThreadUpdate = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(updateThread({ id }));
};
export const chatGlobalSocketThreadCreate =
  (event: { thread_id: number }) => async (dispatch: AppDispatch) => {
    await dispatch(addThread(event.thread_id));
  };
export const chatGlobalSocketThreadRemove = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(deleteThreadsItem(id));
};

export const chatGlobalSocketMessageCreated =
  (event: ChatSocketType) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const chatCounter = getState().common.counters.chat;
    const openedThread = getState().chat.thread.data;
    const threadsData = getState().chat.threads.data;
    const openedRely = getState().chat.reply;
    const type = getState().chat.threads.type;
    const eventType = event.thread.is_group ? 'group' : 'personal';
    const isOpenedChatPage = !!type;
    const sound = new Howl({
      src: notificationSound,
      format: ['mp3'],
    });
    Howler.volume(0.6);

    const notifyUser = () => {
      sound.play();
      NotificationService.chatMessage(event.thread, event.message, (messageText: string) => {
        if (event.message.replay_id) {
          dispatch(fastReplyMessageSend(messageText, event.thread.id, event.message.replay_id));
          dispatch(seenReply(event.message.replay_id));
          dispatch(getGlobalChatCounters());
          dispatch(getThreadCounter(event.thread.id));
        } else {
          dispatch(seenThread(event.thread.id));
          dispatch(fastMessageSend(messageText, event.thread.id));
          dispatch(getGlobalChatCounters());
          dispatch(getThreadCounter(event.thread.id));
        }
      });
    };

    const updateGlobalCounters = () => {
      if (event.message.replay_id) {
        dispatch(getGlobalChatCounters());
      } else {
        if (eventType === 'group') {
          dispatch(
            setChatCounters({
              ...chatCounter,
              count_unread_group: chatCounter.count_unread_group + 1,
              count_unread_message: chatCounter.count_unread_message + 1,
            }),
          );
        } else {
          dispatch(
            setChatCounters({
              ...chatCounter,
              count_unread_private: chatCounter.count_unread_private + 1,
              count_unread_message: chatCounter.count_unread_message + 1,
            }),
          );
        }
      }
    };

    if (isOpenedChatPage) {
      const foundThread = threadsData.find((item) => item.id === event.thread.id);

      if (openedThread?.id === event.thread.id) {
        dispatch(addThreadsItems(event.thread));

        if (event.message.replay_id === null) {
          dispatch(seenThread(event.thread.id));
        } else {
          if (event.message.replay_id !== openedRely?.message?.id) {
            notifyUser();
            updateGlobalCounters();
            dispatch(getThreadCounter(event.thread.id));
          } else {
            dispatch(seenReply(event.message.replay_id));
          }
        }
      } else {
        notifyUser();
        if (foundThread?.id) {
          dispatch(addThreadsItems(event.thread));
          if (event.message.replay_id === null) {
            dispatch(
              changeThreadCounter({
                id: event.thread.id,
                count: foundThread.count_unread_messages + 1,
              }),
            );
            updateGlobalCounters();
          } else {
            updateGlobalCounters();
            dispatch(getThreadCounter(event.thread.id));
          }
        } else {
          updateGlobalCounters();
          if (type === eventType) {
            dispatch(addThread(event.thread.id));
          }
        }
      }
    } else {
      notifyUser();
      updateGlobalCounters();
    }
  };

export const chatSocketThreadUpdated = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(updateThread({ id }));
};
